import React, { useEffect, useRef, useState } from "react";
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";
import CRUDTable from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable";
import CRUDTableHeader from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader";
import CRUDth from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth";
import CRUDTableRow from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow";
import ShortTextCell from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell";
import ViewButton from "../../../../Partials/Layouts/CRUDs/CRUDButtons/ViewButton/ViewButton";
import Modal from "../../../../Partials/Elements/Modal/Modal";
import ViewDemandProducts from "./ViewDemandProducts";
import { DEMAND_PRODUCTS_API } from "../../../../../Utilities/APIs/APIs";
import ImageCell from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ImageCell/ImageCell";

function DemandProducts() {
  const [demandProducts, setDemandProducts] = useState([]);
  const screenHeaerRef = useRef(null);
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);

  const [showViewSection, setShowViewSection] = useState(false);
  const [toggleFetch, setToggleFetch] = useState(false);
  const [targetID, setTargetID] = useState(null);

  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);

  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");

  const axiosInstance = useAxiosInstance();

  useEffect(() => {
    if (screenHeaerRef.current) {
      setScreenHeaderHeight(screenHeaerRef.current.clientHeight);
    }
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPage(1);
      setSearch(searchInput.trim());
    }, 400);

    return () => clearTimeout(timeout);
  }, [searchInput]);

  useEffect(() => {
    async function fetchDemandProducts() {
      try {
        const { data } = await axiosInstance.get(
          `${DEMAND_PRODUCTS_API}?page=${page}&limit=50&search=${encodeURIComponent(search)}`
        );

        setDemandProducts(Array.isArray(data?.demandProducts) ? data.demandProducts : []);
        setPage(data?.page || 1);
        setPages(data?.pages || 1);
        setTotal(data?.total || 0);
      } catch (error) {
        console.error("Failed to fetch demand products:", error);
        setDemandProducts([]);
        setPages(1);
        setTotal(0);
      }
    }

    fetchDemandProducts();
  }, [toggleFetch, axiosInstance, page, search]);

  function triggerFetch() {
    setToggleFetch((prevState) => !prevState);
  }

  return (
    <>
      <div className="screen_header" ref={screenHeaerRef}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          <h1 className="screen_heading" style={{ margin: 0 }}>
            {search
              ? `Demand Products (${total} demand${total !== 1 ? "s" : ""} found)`
              : `Demand Products (${total} in total)`}
          </h1>

          <div style={{ minWidth: "280px", maxWidth: "360px", width: "100%" }}>
            <input
              type="text"
              placeholder="Search by product name"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              style={{
                width: "100%",
                height: "42px",
                borderRadius: "8px",
                border: "1px solid rgba(255,255,255,0.08)",
                background: "#111426",
                color: "#fff",
                padding: "0 14px",
                outline: "none",
              }}
            />
          </div>
        </div>
      </div>

      <CRUDTable screenHeaderHeight={screenHeaderHeight}>
        <CRUDTableHeader>
          <CRUDth th="Email" />
          <CRUDth th="Product Name" />
          <CRUDth th="Size" />
          <CRUDth th="Image" />
          <CRUDth th="Actions" />
        </CRUDTableHeader>

        <tbody>
          {demandProducts.map((demandProduct) => (
            <CRUDTableRow key={demandProduct._id}>
              <ShortTextCell text={demandProduct?.email || "-"} />
              <ShortTextCell text={demandProduct?.productSize?.product?.name || "-"} />
              <ShortTextCell text={demandProduct?.productSize?.size?.name || "-"} />
              <ImageCell imgSrc={demandProduct?.productSize?.product?.cardFrontImage || ""} />

              <td>
                <div className="action_buttons_wrapper">
                  <div className="action_buttons">
                    <ViewButton
                      setShowViewSection={setShowViewSection}
                      targetID={demandProduct._id}
                      setTargetID={setTargetID}
                      tooltipName={"View"}
                      tooltipContent={"View"}
                    />
                  </div>
                </div>
              </td>
            </CRUDTableRow>
          ))}

          {demandProducts.length === 0 && (
            <tr>
              <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                No demand products found.
              </td>
            </tr>
          )}
        </tbody>
      </CRUDTable>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        <button
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          disabled={page === 1}
        >
          Prev
        </button>

        <span>
          Page {page} of {pages}
        </span>

        <button
          onClick={() => setPage((prev) => Math.min(prev + 1, pages))}
          disabled={page === pages}
        >
          Next
        </button>
      </div>

      {showViewSection && targetID && (
        <Modal
          extraClass={"small"}
          modalHeading={`View Demand Product`}
          setShowModalContent={setShowViewSection}
        >
          <ViewDemandProducts targetID={targetID} />
        </Modal>
      )}
    </>
  );
}

export default DemandProducts;